import { Channel, ConversationRestrictionsData, EmbedInterface, From, GroupInterface, MessageAuth, MessageInterface, Slug, UserAddress, UserInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// Controllers
// LINK apps/messaging/src/API/Message/Message.Controller.ts
// LINK apps/messaging/src/API/Quests/Quests.Controller.ts
// LINK apps/channels/src/API/Message/Message.Controller.ts

export class MessagingAPI {
  static async sendMessageToMessagingServer(
    message: MessageInterface,
    channel?: Channel,
    params?: { currentURL?: string; address?: UserAddress; callSid?: string, conversationRestrictions?: ConversationRestrictionsData },
  ) {
    let frame: any = {
      message: message,
      // channel:channel,
      // currentURL:currentURL
    };
    if (channel) {
      frame.channel = channel;
    }
    // if (params?.currentURL) {
    //   frame.currentURL = params.currentURL;
    // }
    // if (params?.address) {
    //   frame.address = address;
    // }

    if (params) {
      frame = { ...frame, ...params };
    }

    return APIService.Messaging.post<boolean>(`/message`, frame);
  }

  static async sendVoiceMessageToMessagingServer(text: string, from: From, callSid: string) {
    const frame: any = {
      text: text,
      from: from,
      callSid: callSid,
    };

    return APIService.Messaging.post<boolean>(`/message/voice`, frame);
  }

  static async sendUserToQuest(orgId: number, userId: number, questSlug: Slug, changeToChannel?: Channel) {
    const url = `/quests/org/${orgId}/user/${userId}/slug/${questSlug}`;
    const query = changeToChannel ? `?changeToChannel=${changeToChannel}` : "";
    return APIService.Messaging.post<boolean>(url + query, {});
  }

  static async sendMessageToChannelsServer(message: MessageInterface) {
    return APIService.Channels.post<boolean>(`/message`, message);
  }
}
